export const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
export const BASE_URL_V2 = `${process.env.REACT_APP_BASE_URL_V2}`;
export const BASE_SSE_URL = `${process.env.REACT_APP_SSE_URL}`;
export const CSS_URL = `${process.env.REACT_APP_CSS}`;
export const APP_LINK_ADJUST = process.env.REACT_APP_LINK_ADJUST;
export const APP_SCHEME_BASE = process.env.REACT_APP_APP_SCHEME_BASE;
export const BLOCKED_APP_CHANNELS = ['009002'];
